import { formatEasternDate, formatEasternDateTime } from 'helpers/dates'
import {
  STATEMENT_NOT_MAILED_REASON_LABEL,
  STATEMENT_PRINT_RUN_ITEM_STATUS_COLOR,
  STATEMENT_PRINT_RUN_ITEM_STATUS_LABEL,
  StatementNotMailedReason,
  StatementPrintRunItemDto,
  StatementPrintRunItemStatus,
} from 'store/types'

export const formatDateTime = (date?: string | Date | null) => formatEasternDateTime(date, '--')

export const formatDate = (date?: string | Date | null) => formatEasternDate(date, '--')

export const formatMoney = (value: number | undefined | null) => `$${Number(value || 0).toFixed(2)}`

export const formatPatientName = (lastName?: string | null, firstName?: string | null) =>
  [lastName, firstName].filter(Boolean).join(', ') || '--'

export const apiErrorMessage = (error: unknown, fallback: string) =>
  (error as { data?: { message?: string } })?.data?.message || fallback

// Label, color and tooltip of a printed envelope's outcome.
export const describeMailing = (mailing: StatementPrintRunItemDto) => {
  const status = mailing.status as StatementPrintRunItemStatus
  const date = mailing.returnedAt || mailing.mailedAt || mailing.printedAt
  const reason = mailing.notMailedReason
    ? STATEMENT_NOT_MAILED_REASON_LABEL[mailing.notMailedReason as StatementNotMailedReason]
    : null

  return {
    label: STATEMENT_PRINT_RUN_ITEM_STATUS_LABEL[status] || status,
    color: STATEMENT_PRINT_RUN_ITEM_STATUS_COLOR[status] || '#6c757d',
    tooltip: [formatDate(date), [reason, mailing.note].filter(Boolean).join(': ')].filter(Boolean).join(' — '),
  }
}
